import { createSlice } from "@reduxjs/toolkit";

export const cartSlice = createSlice({
  name: "cart",
  initialState: { skus: [], bundles: [] },

  reducers: {
    addToCart: (state, action) => {
      const sku = action.payload;
      const newSku = {
        id: sku.id,
        skuNameId: sku.skuNameId,
        images: sku.imageList,
        availableQuantity: sku.availableQuantity,
        quantity: sku.quantity,
        commercialName: sku.commercialName,
        name: sku.name,
        brandName: sku.skuBrand,
        marketPrice: sku.marketPrice,
        inventoryPrice: sku.inventoryPrice || sku.suggestedSellingPrice,
        hasPriceTiers: sku.nextPriceTier ? true : false,
        nextPriceTier: sku.nextPriceTier,
        skuPriceTieringType: sku.skuPriceTieringType,
        maxAvailableQuantityForPriceTiering:
          sku.maxAvailableQuantityForPriceTiering,
        maximumQuantityForExpressForSku: sku.maximumQuantityForExpressForSku,
        maximumQuantityForExpressForSkuName:
          sku.maximumQuantityForExpressForSkuName,
      };
      return {
        ...state,
        skus: [...state.skus, newSku],
      };
    },

    editCartItem: (state, action) => {
      const {
        payload: { newItemData, itemPosition },
      } = action;
      return {
        ...state,
        skus: state.skus.map((sku, index) =>
          index === itemPosition
            ? {
                images: newItemData.imageList,
                quantity: newItemData.quantity,
                name: newItemData.name,
                skuNameId: newItemData.skuNameId,
              }
            : sku
        ),
      };
    },

    increaseQuantity: (state, action) => {
      const { skuId, priceTiersData, bundleId, skuIndex } = action.payload;
      if (skuId) {
        const updatedSkus = state.skus.map((item) => {
          if (item.id === skuId) {
            const updatedItem = { ...item, quantity: item.quantity + 1 };
            if (priceTiersData) {
              return { ...updatedItem, ...priceTiersData };
            }
            return updatedItem;
          }
          return item;
        });
        return { ...state, skus: updatedSkus };
      } else if (bundleId) {
        const updatedBundles = state.bundles.map((bundle) => {
          if (bundle.id === bundleId) {
            return { ...bundle, quantity: bundle.quantity + 1 };
          }
          return bundle;
        });
        return { ...state, bundles: updatedBundles };
      } else {
        const updatedSkus = state.skus.map((item, idx) => {
          if (idx === skuIndex) {
            return { ...item, quantity: item.quantity + 1 };
          }
          return item;
        });
        return { ...state, skus: updatedSkus };
      }
    },
    decreaseQuantity: (state, action) => {
      const { skuId, priceTiersData, bundleId, skuIndex } = action.payload;
      if (skuId) {
        const updatedSkus = state.skus.map((item) => {
          if (item.id === skuId) {
            const updatedItem = { ...item, quantity: item.quantity - 1 };
            if (priceTiersData) {
              return { ...updatedItem, ...priceTiersData };
            }
            return updatedItem;
          }
          return item;
        });
        return { ...state, skus: updatedSkus };
      } else if (bundleId) {
        const updatedBundles = state.bundles.map((bundle) => {
          if (bundle.id === bundleId) {
            return { ...bundle, quantity: bundle.quantity - 1 };
          }
          return bundle;
        });
        return { ...state, bundles: updatedBundles };
      } else {
        const updatedSkus = state.skus.map((item, idx) => {
          if (idx === skuIndex) {
            return { ...item, quantity: item.quantity - 1 };
          }
          return item;
        });
        return { ...state, skus: updatedSkus };
      }
    },
    removeFromCart: (state, action) => {
      const {
        payload: { skuId, index },
      } = action;

      if (skuId) {
        const newSkus = state.skus.filter((item) => item.id !== skuId);

        return { ...state, skus: newSkus };
      } else {
        const newSkus = state.skus.filter((_, idx) => idx !== index);

        return { ...state, skus: newSkus };
      }
    },
    updateItemsMisMatch: (state, action) => {
      const stateSkus = [
        ...state.skus,
        ...state.bundles.flatMap((bundle) => bundle.skuList.map((sku) => sku)),
      ];

      stateSkus.map((cartItem) => {
        if (action.payload.includes(cartItem.id)) {
          cartItem.isMisMatch = true;
          return cartItem;
        } else {
          cartItem.isMisMatch = false;
          return cartItem;
        }
      });
    },
    makeAllItemsMatch: (state) => {
      const stateSkus = [
        ...state.skus,
        ...state.bundles.flatMap((bundle) => bundle.skuList.map((sku) => sku)),
      ];

      stateSkus.map((cartItem) => {
        if (cartItem.isMisMatch) {
          cartItem.isMisMatch = false;
          return cartItem;
        } else {
          return cartItem;
        }
      });
    },
    addBundleToCart: (state, action) => {
      const bundle = action.payload;

      return {
        ...state,
        bundles: [...state.bundles, bundle],
      };
    },
    removeBundleFromCart: (state, action) => {
      const bundleId = action.payload;

      const newBundles = state.bundles.filter((item) => item.id !== bundleId);

      return { ...state, bundles: newBundles };
    },
    emptyCart: () => {
      return { skus: [], bundles: [] };
    },
  },
});

export const {
  addToCart,
  editCartItem,
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
  emptyCart,
  updateItemsMisMatch,
  makeAllItemsMatch,
  addBundleToCart,
  removeBundleFromCart,
} = cartSlice.actions;

export const selectCart = (state) => state.cart;
export const cartSkusSelector = (state) => state.cart.skus;
export const skuSelector = (state, skuId) =>
  state.cart.skus.find((sku) => sku.id === skuId);

export default cartSlice.reducer;
